import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
import Automotive from '../../img/automotive_expertise.jpg';
import RealEstate from '../../img/real_estate_expertise.jpg';
import Event from '../../img/events_expertise.jpg';
import Landscape from '../../img/landscape_expertise.jpg';

const services = [
  {
    id: 'service_automotive',
    title: 'Automotive',
    description:
      'Automotive photography, car commercials, motorsports. Dynamic visuals that capture speed, design, and emotion.',
    image: Automotive.src,
    alt: 'High-performance sports car with scenic background and dramatic lighting in automotive photography setting',
    icon: 'KeyIcon' as const,
  },
  {
    id: 'service_real_estate',
    title: 'Real Estate',
    description:
      'Real estate photography, architectural shoots, interior design. Stunning visuals that highlight properties and spaces.',
    image: RealEstate.src,
    alt: 'Modern real estate property with sleek architecture and well-designed interior in real estate photography setting',
    icon: 'HomeIcon' as const,
  },
  {
    id: 'service_event',
    title: 'Event Coverage',
    description:
      'Corporate events, conferences, social gatherings. Capturing the energy and moments that make your event unforgettable.',
    image: Event.src,
    alt: 'Car racing on track with motion blur and dynamic composition in motorsports photography setting',
    icon: 'CalendarIcon' as const,
  },
  {
    id: 'service_landscape',
    title: 'Landscape & Architectural',
    description:
      'Landscape and architectural photography. Showcasing the beauty of natural and built environments with artistic vision.',
    image: Landscape.src,
    alt: 'Breathtaking landscape with dramatic sky and vibrant colors in nature photography setting',
    icon: 'GlobeAmericasIcon' as const,
  },
];

export default function ServicesSection() {
  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-16 reveal">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-4 tracking-tight">
            Our Expertise
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl">
            Professional photography services tailored to your unique needs and vision
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="group relative overflow-hidden rounded-2xl glass-panel hover:bg-card transition-all duration-500 reveal"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <AppImage
                  src={service.image}
                  alt={service.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent" />
              </div>

              {/* Content */}
              <div className="p-6 space-y-4">
                <div className="w-12 h-12 rounded-lg bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors">
                  <Icon name={service.icon} size={24} className="text-white" />
                </div>
                <h3 className="text-xl font-bold text-white">{service.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {service.description}
                </p>
              </div>

              {/* Hover Arrow */}
              {/* <div className="absolute bottom-6 right-6 w-10 h-10 rounded-full border border-white/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <Icon name="ArrowRightIcon" size={16} className="text-white" />
              </div> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
